/* eslint-disable no-console */
/* eslint-disable max-len */
/* eslint-disable multiline-ternary */
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import CloseIcon from '@mui/icons-material/Close';
import {
	Box,
	Dialog, DialogContent,
	DialogTitle,
	IconButton, Stack,
	Tooltip
} from '@mui/material';
import React from 'react';
import VideoPreview from './VideoPreview';
import DocViewer, { DocViewerRenderers } from 'react-doc-viewer';

type PreviewModalProps = {
    open: boolean;
    handleClose: () => void;
    // mediaList: Array<{ id: number; img: string; name: string }>;
    mediaList: Array<any>;
    currentIndex: number;
    setCurrentIndex: (index: number) => void;
};

const DocPreview: React.FC<PreviewModalProps> = ({
	open,
	handleClose,
	mediaList,
	currentIndex,
	setCurrentIndex
}) =>
{
	// const { img, name } = mediaList[currentIndex];
	const currentMedia = mediaList[currentIndex];

	// const isVideo = /\.(mp4|webm|ogg)$/i.test(currentMedia?.name);
	// const isVideo = currentMedia?.type.match('video') || currentMedia?.type === 'youtube';
	// const isImage = currentMedia?.type.match('image');
	const isDocument = currentMedia?.type.match('application');

	return (
		<Dialog
			open={open}
			onClose={handleClose}
			maxWidth='md'
			// fullScreen
			sx={{
				borderRadius       : '0 !important',
				background         : 'transparent',
				'& .MuiPaper-root' : {
					backgroundColor : 'transparent',
					boxShadow       : 'none'
				}
			}}
		>
			<DialogTitle sx={{ background: 'rgba(0,0,0,0.9)' }}>
				<Stack direction='row' justifyContent='end' alignItems='center' width='var(--percent100)'>
					{/* <Typography color='var(--whiteColor)'>{name}</Typography> */}
					<Box display='flex' justifyContent='end' alignItems='center'>
						<Tooltip title='Close'>
							<IconButton onClick={handleClose}>
								<CloseIcon sx={{ color: 'var(--whiteColor)', fontSize: 'var(--pixel16)' }} />
							</IconButton>
						</Tooltip>
					</Box>
				</Stack>
			</DialogTitle>
			<DialogContent
				sx={{
					background     : 'rgba(0,0,0,0.9)',
					display        : 'flex',
					justifyContent : 'center'
				}}
			>
				<Box
					display='flex'
					justifyContent='center'
					alignItems='center'
					flexDirection='column'
					position='relative'
					sx={{ height: '75vh', width: '90vw' }}
				>
					<IconButton
						onClick={() => setCurrentIndex(currentIndex - 1)}
						sx={{ position: 'absolute', left: 10, top: 'var(--percent50)', transform: 'translateY(-50%)', color: 'var(--whiteColor)', zIndex: '999', background: 'rgba(0, 0, 0, 0.7)' }}
						disabled={currentIndex === 0}
					>
						<ArrowBackIosNewIcon />
					</IconButton>

					{/* {isVideo && <VideoPreview currentMedia={currentMedia}/>}
					{isImage &&
						<img
							src={currentMedia?.url.concat('?new=t')}
							alt={'feed image'}
							style={{
								width        : 'var(--percent100)',
								height       : 'var(--percent100)',
								objectFit    : 'contain',
								borderRadius : 'var(--pixel8)'
								// background   : 'rgba(0, 0, 0, 0.5)'
							}}
						/>
					} */}
					{isDocument &&
						<DocViewer
							documents={[ { uri: currentMedia?.url, fileType: currentMedia?.key?.split('.').pop() } ]}
							pluginRenderers={DocViewerRenderers}
							style={{ width: 'var(--percent100)', height: 'var(--percent100)' }}
						/>
					}
					<IconButton
						onClick={() => setCurrentIndex(currentIndex + 1)}
						sx={{ position: 'absolute', right: 10, top: 'var(--percent50)', transform: 'translateY(-50%)', color: 'var(--whiteColor)', zIndex: '999', background: 'rgba(0, 0, 0, 0.7)' }}
						disabled={currentIndex === mediaList.length - 1}
					>
						<ArrowForwardIosIcon />
					</IconButton>
				</Box>
			</DialogContent>
		</Dialog>
	);
};

export default DocPreview;
